import createIcon from '../../createIcon';

/**
 * @component @name SwitchAccessShortcutAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuNSAxNEgyMC41VjEySDE4LjVWMTRIMTYuNVYxNkgxOC41VjE4SDIwLjVWMTZIMjIuNVYxNFpNNS41NiA4Ljk0TDMuNSA4TDUuNTYgNy4wNkw2LjUgNUw3LjQ0IDcuMDZMOS41IDhMNy40NCA4Ljk0TDYuNSAxMUw1LjU2IDguOTRaTTYuNSAyMUw3LjQ0IDE4Ljk0TDkuNSAxOEw3LjQ0IDE3LjA2TDYuNSAxNUw1LjU2IDE3LjA2TDMuNSAxOEw1LjU2IDE4Ljk0TDYuNSAyMVpNMi44NyAxMi4zN0wxLjUgMTNMMi44NyAxMy42M0wzLjUgMTVMNC4xMyAxMy42M0w1LjUgMTNMNC4xMyAxMi4zN0wzLjUgMTFMMi44NyAxMi4zN1pNMTAuNSAxMkMxMC41IDkuMjcgMTEuNTggNi43MyAxMy4yNSA0Ljc1TDEwLjUgMkgxNy41VjlMMTQuNjggNi4xOEMxMy4zNCA3LjgyIDEyLjUgOS44OCAxMi41IDEyQzEyLjUgMTUuMzIgMTQuNiAxOC4zNiAxNy41IDE5LjgyVjIyQzEzLjQxIDIwLjQxIDEwLjUgMTYuMzUgMTAuNSAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwitchAccessShortcutAdd = createIcon('SwitchAccessShortcutAdd', [
  [
    'path',
    {
      d: 'M22.5 14H20.5V12H18.5V14H16.5V16H18.5V18H20.5V16H22.5V14ZM5.56 8.94L3.5 8L5.56 7.06L6.5 5L7.44 7.06L9.5 8L7.44 8.94L6.5 11L5.56 8.94ZM6.5 21L7.44 18.94L9.5 18L7.44 17.06L6.5 15L5.56 17.06L3.5 18L5.56 18.94L6.5 21ZM2.87 12.37L1.5 13L2.87 13.63L3.5 15L4.13 13.63L5.5 13L4.13 12.37L3.5 11L2.87 12.37ZM10.5 12C10.5 9.27 11.58 6.73 13.25 4.75L10.5 2H17.5V9L14.68 6.18C13.34 7.82 12.5 9.88 12.5 12C12.5 15.32 14.6 18.36 17.5 19.82V22C13.41 20.41 10.5 16.35 10.5 12Z',
      key: 's8rr05',
    },
  ],
]);

export default SwitchAccessShortcutAdd;
